import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FileThumbObj } from 'src/app/models/Lookup';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(id: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurant/ResListPhotosAndVideos?RestaurantId=${id}`);
  }
  delete(ResturantId: number, id: number) {
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResDeleteGallary?ResturantId=${ResturantId}&GallaryId=${id}`, null);
  }
  saveRecord(data: any) {
    const formData = new FormData();
    let files = data.photos.concat(data.videos)
    data.thumbType = [];

    if (files?.length) {
      files.forEach((item: FileThumbObj, index: number) => {
        if (!item.id) { // send new file
          formData.append(String(index), item?.file, item?.file?.name);
          formData.append('thumb-' + index, item?.thumb, item?.thumb?.name);
          data.thumbType.push(item.thumbType);
        }
      });
    }
    delete data['photos'];
    delete data['videos'];
    formData.append('data', JSON.stringify(data));
    return this.http.post(`${environment.apiUrl}/ResRestaurant/ResSaveRestaurantPhotos`, formData);
  }
}
